import React, { useCallback } from 'react';

import { Platform, Pressable, View, ViewStyle } from 'react-native';

import { useTranslation } from 'react-i18next';

import { ProfileKidsIcon, ProfileStandardIcon } from 'assets/images';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { PROFILE_TYPE_KIDS, PROFILE_TYPE_STANDARD } from 'config/testID';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

const {
    PROFILE: { PROFILES_TYPE_STANDARD, PROFILES_TYPE_KIDS },
} = LANGUAGE_KEYS;

type Props = {
    isChildProfile?: boolean;
    onPress: (isChildProfile: boolean) => void;
    style?: ViewStyle;
};

const ProfileTypeItem = ({ style, isChildProfile = false, onPress }: Props) => {
    const { t } = useTranslation();

    const handleOnPress = useCallback(() => {
        onPress(isChildProfile);
    }, [isChildProfile]);

    return (
        <Pressable
            testID={isChildProfile ? PROFILE_TYPE_KIDS : PROFILE_TYPE_STANDARD}
            onPress={handleOnPress}
            style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1 }, style]}
            accessibilityLabel={t(
                isChildProfile ? PROFILES_TYPE_KIDS : PROFILES_TYPE_STANDARD,
            )}
            accessibilityRole={Platform.select({
                web: 'imagebutton',
                default: 'button',
            })}
        >
            <View style={styles.iconContainer}>
                {isChildProfile ? <ProfileKidsIcon /> : <ProfileStandardIcon />}
            </View>
            <Text
                category={ETextCategory.body2}
                color={ETextColor.neutral}
                bold
                center
            >
                {t(
                    isChildProfile
                        ? PROFILES_TYPE_KIDS
                        : PROFILES_TYPE_STANDARD,
                )}
            </Text>
        </Pressable>
    );
};

export default ProfileTypeItem;
